import { Routes, Route, Navigate } from 'react-router-dom';
import Landing from './pages/Landing.jsx';
import Login from './pages/Login.jsx';
import MemberDashboard from './pages/MemberDashboard.jsx';
import AdminDashboard from './pages/AdminDashboard.jsx';
import AdminHub from './pages/AdminHub.jsx';
import NewJob from './pages/NewJob.jsx';
import JobDetail from './pages/JobDetail.jsx';
import Settings from './pages/Settings.jsx';
import AuthCallback from './pages/AuthCallback.jsx';
import Terms from './pages/Terms.jsx';
import PasswordReset from './pages/PasswordReset.jsx';
import AcceptInvite from './pages/AcceptInvite.jsx';
import { RequireAuth, RequireAdmin } from './lib/auth.jsx';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/auth/reset" element={<PasswordReset />} />
      <Route path="/auth/accept-invite" element={<AcceptInvite />} />
      <Route path="/dashboard" element={<RequireAuth><MemberDashboard /></RequireAuth>} />
      <Route path="/jobs/new" element={<RequireAuth><NewJob /></RequireAuth>} />
      <Route path="/jobs/:jobId" element={<RequireAuth><JobDetail /></RequireAuth>} />
      <Route path="/settings" element={<RequireAuth><Settings /></RequireAuth>} />
      <Route path="/settings/agol" element={<RequireAuth><Settings /></RequireAuth>} />
      <Route path="/admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
      <Route path="/admin/desktop" element={<RequireAdmin><AdminHub /></RequireAdmin>} />
      <Route path="/admin/hub" element={<RequireAdmin><AdminHub /></RequireAdmin>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
